import styled from "@emotion/styled";
import { useState } from "react";
import ChevronDown from "../icons/ChevronDown";
import { SecondaryButton } from "./SecondaryButton";
import { BUTTON_PRIMARY_GRADIENT_HOVER, BOX_SHADOW_MEDIUM } from "../theme";

const StyledButton = styled(SecondaryButton)`
  display: flex;
  align-items: baseline;
  gap: 8px;
  box-shadow: ${BOX_SHADOW_MEDIUM};
`;

const DropDownContainer = styled.div`
  position: relative;
`;

const DropDownOptions = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: ${BOX_SHADOW_MEDIUM};
  width: 100%;
`;

const Flip = styled.div<{ isOpen: boolean }>`
  transform: scaleY(${({ isOpen }) => (isOpen ? -1 : 1)});
`;

export const DropDownOption = styled(SecondaryButton)`
  border-radius: 0;
  width: 100%;
  box-shadow: none;
  &:hover {
    box-shadow: none;
    background: ${BUTTON_PRIMARY_GRADIENT_HOVER};
  }
`;

interface DropDownButtonProps {
  className?: string;
  children: React.ReactNode;
  options: React.ReactNode[];
}

const DropDownButton = ({
  children,
  className,
  options,
}: DropDownButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <DropDownContainer>
      <StyledButton
        className={className}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        {children}
        <Flip isOpen={isOpen}>
          <ChevronDown />
        </Flip>
      </StyledButton>
      {isOpen && (
        <DropDownOptions
          onClick={() => {
            setIsOpen(false);
          }}
        >
          {options}
        </DropDownOptions>
      )}
    </DropDownContainer>
  );
};

export default DropDownButton;
